import React from 'react';

const PhoneWhiteIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.193 12.437L13.79 12.1626C13.2129 12.0964 12.6453 12.2951 12.2385 12.7019L10.4977 14.4426C7.82034 13.0803 5.62546 10.8949 4.26313 8.20806L6.01335 6.45784C6.42016 6.05103 6.61884 5.48339 6.55261 4.90629L6.27825 2.5222C6.16472 1.56667 5.36057 0.847656 4.39558 0.847656H2.75889C1.68983 0.847656 0.800532 1.73696 0.866757 2.80602C1.36817 10.8854 7.8298 17.3376 15.8997 17.839C16.9688 17.9053 17.8581 17.0159 17.8581 15.9469V14.3102C17.8676 13.3547 17.1485 12.5505 16.193 12.437Z" fill="currentColor"/>
    </svg>
  );
};

export default PhoneWhiteIcon;
